import styled from "styled-components";

export const DeletButtonStyle = styled.div`
  background-color: ${({ disabled }) => (disabled ? "gray" : "red")};
  color: white;
  width: 300px;
  height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  font-family: medium-pro, sans-serif;
  align-self: center;
  border-radius: 25px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  margin: 0 0 10px 0;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};

  @media screen and (max-width: 1024px) {
    width: 250px;
    height: 70px;
  }
  @media screen and (max-width: 500px) {
    width: 200px;
    height: 70px;
  }
`;
